import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseFormComponent } from '@classes/extends';
import { FicheclientService as FicheClientService, RFRace, Race } from '@estel-numerique/galaclick-api';
import {
    FiltreHelper,
    FiltresService,
    TraductionCoreService,
    TypeFiltre,
    ValidatorPatternService
} from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { DialogGalaComponent } from '../../../../composants/dialog-gala/dialog-gala.component';
import { SelectFiltre, SelectGala } from '../../../../composants/select/select.component';
import { MatButton } from '@angular/material/button';

export interface FicheClientAteliersComponentData {
    idClient: number;
    listeRaces: Race[];
    fromhisto: boolean;
    race?: Race;
}

@Component({
    templateUrl: 'ficheclient-ateliers.component.html',
    imports: [DialogGalaComponent, SelectFiltre, FormsModule, ReactiveFormsModule, SelectGala, MatButton]
})
export class FicheClientAteliersComponent extends BaseFormComponent implements OnInit {
    public traductionCore = inject(TraductionCoreService);
    public validPattern = inject(ValidatorPatternService);
    private formBuilder = inject(UntypedFormBuilder);
    private wsFicheClient = inject(FicheClientService);
    private filtresService = inject(FiltresService);
    private ref = inject(ChangeDetectorRef);
    private dialogRef = inject<MatDialogRef<FicheClientAteliersComponent>>(MatDialogRef);
    public data = inject<FicheClientAteliersComponentData>(MAT_DIALOG_DATA);

    public codeModule: string = Constantes.CodeOption.CFICHECLIENT; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    @Input() public titre: string;
    @Output() savedUpdate = new EventEmitter<Race>();
    @Output() savedCreate = new EventEmitter<Race[]>();

    // Traductions
    protected lgTrad: Record<string, string> = {};

    public race: Race = {};
    public listeRfRacesFiltre: TypeFiltre<string>[] = [];
    public listeRfRaces: RFRace[] = [];
    public listeRaces: Race[] = [];
    public currentListeRaces: Race[] = [];
    public idClient: number;
    public isEdition: boolean;
    public isFromHisto: boolean;

    constructor() {
        super();
        this.lgTrad = {
            AFFRACES: this.translate.instant('APPFICHECLIENT.AFFRACES'),
            RACES: this.translate.instant('APPFICHECLIENT.RACES'),
            DEBUT: this.translate.instant('DEBUT'),
            FIN: this.translate.instant('FIN'),
            BEGINNINGDATE: this.translate.instant('BEGINNINGDATE'),
            ENDDATE: this.translate.instant('ENDDATE'),
            ENR: this.translate.instant('ENR'),
            RET: this.translate.instant('RET'),
        };
        this.formData = this.formBuilder.group({
            RFRACE: [null],
        });
    }

    ngOnInit() {
        super.ngOnInit();
        this.show(this.data.idClient, this.data.listeRaces, this.data.fromhisto, this.data.race).catch(e => this.util.fErreur(e));
    }
    // =========================================================================
    // CHARGEMENT CONTEXTE
    // =========================================================================

    private async show(idClient: number, currentListeRaces: Race[], isFromHisto: boolean, race?: Race) {
        try {
            this.util.showLoader();

            this.idClient = idClient;
            this.isFromHisto = isFromHisto;
            this.currentListeRaces = Object.assign([], currentListeRaces);
            this.listeRfRaces = await this.wsCacheLow.getRefRace().toPromise();

            if (race) {
                this.race = race;
                this.isEdition = true;
            } else {
                this.listeRfRacesFiltre = await this.filtresService.getFiltreRFRace(this.currentListeRaces);
                this.isEdition = false;
            }

            this.formData.markAsPristine();
            this.formData.markAsUntouched();

            this.chargerForm();
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    async enregistrerRaces() {
        if (this.hasRaceActive()) {
            this.util.fErreur(this.translate.instant('APPFICHECLIENT.ERRORHISTORACE'));
        } else {
            this.util.showLoader();
            try {
                this.validationFormulaire(this.formData);
                this.getResultatFromForm(this.idClient);
                if (this.formData.valid) {
                    if (this.isEdition) {
                        this.race = await this.wsFicheClient.updateRace(this.idClient, this.race).toPromise();
                        this.savedUpdate.emit(this.race);
                    } else {
                        this.listeRaces = await this.wsFicheClient.postRace(this.idClient, this.listeRaces).toPromise();
                        this.savedCreate.emit(this.listeRaces);
                    }
                    this.hideModal();
                }
            } catch (e) {
                this.util.fErreur(e);
            } finally {
                this.util.hideLoader();
            }
        }
    }

    public hasRaceActive() {
        // On vérifie qu'il n'y a pas déjà la même race avec une action active dessus
        if (this.isFromHisto && this.race) {
            return this.currentListeRaces.find((r: Race) => {
                return r.IDRACECLIENT != this.race.IDRACECLIENT
                    && r.RFRACE.CORABO == this.race.RFRACE.CORABO;
            });
        }
        return false;
    }

    public getResultatFromForm(idClient: number) {
        Object.assign(this.race, this.formData.value);
        // Si c'est pas une édition on créé automatiquement les races qui ne seront pas dans l'UL mais dans l'atelier lait
        if (!this.isEdition) {
            const selectionRaces = FiltreHelper.getSelectionAsString(this.listeRfRacesFiltre);
            selectionRaces.forEach((corabo: string) => {
                const rf: RFRace = this.listeRfRaces.find((race: RFRace) => {
                    return race.CORABO == corabo;
                });
                this.listeRaces.push({
                    ATLAIT: '1',
                    PRESENCEUL: 0,
                    RFRACE: rf,
                    SOURCE: "[\"GR\"]",
                    IDCLIENT: idClient,

                });
            });
        } else {
            // Sinon, si on est dans le cas d'une race FCM (presence UL et atelier lait = 1), ça veut dire qu'on fait une sortie d'atelier
            if (this.checkIsFormDDebut()) {
                this.race.ATLAIT = '0';
            }
        }
    }

    public chargerForm() {
        this.ref.detectChanges();

        if (this.isEdition) {
            this.race.RFRACE = this.listeRfRaces.find((rf: RFRace) => {
                return this.race.RFRACE.CORABO == rf.CORABO;
            });
            this.formData.reset(this.race);
            this.formData.markAsUntouched();

        }
    }

    public checkIsFormDDebut() {
        if (!this.isEdition || (this.race?.PRESENCEUL == 1 && this.race.ATLAIT == '1')) {
            return true;
        }
        return false;
    }

    public isOperationUl() {
        if (this.race.PRESENCEUL == 1) {
            return true;
        }
        return false;
    }



    askHideModal() {
        if (!this.isEdition && !this.formData.untouched) {
            this.util.fConfirm(this.translate.instant('QUITNOSAVE'), () => {
                this.hideModal();
            }, this.translate.instant('MODIFDONE'));
        } else {
            this.hideModal();
        }
    }

    hideModal() {
        this.resetModalValue();
        this.dialogRef.close();
    }

    resetModalValue() {
        this.race = {};
        this.listeRaces = [];
        this.formData.reset();
        this.formData.markAsPristine();
        this.formData.markAsUntouched();
    }

}
